/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-10-08 16:31:29
 */
export default {
  lang: "英语",
  landing: {
    name1: "Відкрити Carlcare",
    name2: "Зарезервувати",
    name3: "За допомогою Carlcare ви в будь-який час можете перевірити своє замовлення.",
    name4: "",
    name5: "Проведіть пальцем управо",
    name6: "Перевірку завершено",
  },
  order: {
    name1: "Виберіть модель пристрою",
    name2: "Опис несправності",
    name3: "Натисніть, щоб вибрати сервісний центр",
    name4: "Сервісний центр:",
    name5: "Час резервування:",
    name6: "Докладно опишіть проблему, що виникла у вашому пристрої.",
    name7: "Натисніть, щоб вибрати час прибуття",
    name8: "Введіть правильні контактні дані, щоб ми могли зв’язатися з вами",
    name9: "Доступний такий час бронювання:",
    name10: "Введіть свій номер телефону",
    name11: "Ціна",
    name12: "Особисті відомості:",
    name13: "Введіть своє ім’я",
    name14: "Надіслати",
    name15: "Скасувати",
    name16: "OK",
  },
  shops: {
    name1: "На основі обраного бренду вас можуть обслужити наступні магазини!",
    name2: "Незабаром і в інших роздрібних магазинах. Залишайтеся з нами!",
  },
  price: {
    name1: "Бренд",
    name2: "Модель",
    name3: "ЕЛЕМЕНТ",
    name4: "Ціна",
    name5: "Дружнє нагадування:",
    name6: "Ці ціни лише довідкові, а фактична ціна залежить від вашого пристрою.",
    name7: "Якщо спеціального символу немає, одиниця ціни - це місцева валюта.",
    name8: "Вибачте! Інформація про ціни в поточному регіоні недоступна.",
    name11:"Вартість роботи",
    name12:"Загальна сума",
    name13: "5. Якщо вартість роботи позначено знаком «/», це означає, що вартість роботи потрібно уточнити в магазині.",
    item_main_board: "Системна плата",
    item_screen_frame: "Екран (рамка)",
    item_screen_screen_frame: "Допоміжний екран (рамка)",
    item_touch_screen: "Сенсорний екран",
    item_camera: "Камера",
    item_fixed_focus_camera: "Камера з фіксованим фокусом",
    item_auto_focus_camera: "Камера з автоматичним фокусом",
    item_screen: "Екран",
    item_secondary_screen: "Допоміжний екран",
    item_fingerprint_module: "Модуль відбитка пальця",
    item_speaker: "Динамік",
    item_receiver: "Приймач",
    item_small_board: "Мала дошка",
    item_battery_cover: "Кришка відсіку акумулятора",
    item_battery: "Акумулятор",
    item_charger: "Зарядний пристрій",
    item_usb_cable: "USB-кабель",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "Немає даних",
    name2: "Постачальник послуг:",
    name3: "Бренд послуги:",
    name4: "Телефон:",
    name5: "Замовлена кількість:",
    name6: "Оцінка обслуговування",
    name7: "Середовище обслуговування:",
    name8: "Ставлення персоналу:",
    name9: "Ефективність обслуговування:",
    name10: "Якість обслуговування:",
    name11: "Оцінка клієнта",
    name12:"до",
    name13:"Закрито",
  },
  reserSuccess: {
    // name1:
    //   "Відкрити Carlcare",
    name1: "Зробіть знімок екрана з інформацією про бронювання та збережіть його як квитанцію для доступу до пріоритетного обслуговування.",
    name2: "Надіслано",
    name3: "1. Видаліть дані",
    name4: "Заздалегідь створіть резервну копію важливих особистих даних, що зберігаються у вашому телефоні",
    name5: "2. Зніміть пароль під час увімкнення живлення",
    name6: "Перш ніж іти в сервісний центр:",
    name7: "Сервісний центр:",
    name8: "Час резервування:",
    name9: "Опис несправності",
    name10: "Модель пристрою:",
    name11: "Номер замовлення:",
    name12: "Інформація про замовлення",
  },
  title: {
   
    name1: "Підтримує такі країни:",
    name2: "Вибрати модель",
    name3: "Резервування",
    name4: "Дані про сервісний центр",
    name5: "Вибрати сервісний центр",
  },
  error: {
    
    name1: "Немає даних. Перевірте інформацію про ремонт",
    name2: "Потрібна допомога?Зв\'яжіться з нами.",
    name3: "На жаль, у цьому регіоні немає центру Carlcare.",
    name4: "Спочатку виберіть сервісний центр",
    name5: "Не вдалося",
    name6: "Спочатку виберіть модель пристрою",
    name7: "Відомості",
    name8: "Докладно опишіть, що вам потрібно",
    name9: "",
  },
  add1:{
    "name0": "uk-rUA",
    "name1": "Ваше замовлення підтверджено. З нетерпінням чекаємо на ваш приїзд.",
    "name2": "Виберіть місто",
    "name3": "Введіть номер телефону з %1$s цифр.",
    "name4": "Будні години",
    "name5": "Понеділок",
    "name6": "Вівторок",
    "name7": "Середа",
    "name8": "Четвер",
    "name9": "П\\'ятниця",
    "name10": "Субота",
    "name11": "Неділя",
    "name12": "Введіть країну та виконайте пошук"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "pick-up time",
    "name7": "tap to select pick-up time",
    "name8": "pick-up address",
    "name9": "Pleasee input your house number/street/district/province",
    "name10": "Pleasee input postal code",
    "name11": "Add returning address",
    "name12": "returning address",
    "name13": "Інше",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"Натисніть, щоб перенаправити",
    name3:"Відкрийте програму Carlcare, щоб оцінити замовлення",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"Виберіть послугу",
    name7:"Безкоштовне чищення",
    name8:"Оновлення ПЗ",
  },
  cancelorder:{
    "cancelReason0": "Невірна інформація",
    "cancelReason1": "Неможливо прибути вчасно",
    "cancelReason2": "Дубльоване замовлення/не моє замовлення",
    "cancelReason3": "Помилка не виникає повторно",
    "cancelReason4": "Лише для випробування/запиту/події/…",
    "cancelReason5": "Висока ціна",
    "cancelReason6": "Брак матеріалу",
    "cancelReason7": "Відсутність диференційованих послуг",
    "cancelReason8": "Магазин розташований надто далеко",
    "cancelReason9": "Магазин закритий",
    "cancelReason10": "Низька якість обслуговування",
    "cancelReason11": "Заміна/ремонт продукції інших виробників",
    "cancelReason12": "Не вдалося знайти магазин",
    "cancelReason13": "Інше",
    "cancelOrder": "Скасувати замовлення",
    "reason_dialog_title": "Повідомте причину скасування",
    "Cancel": "Скасувати",
    "OK": "OK",
    "name1": "Введіть код перевірки",
    "name2": "Недійсний код перевірки",
    "repair_reservation_detail_canceled": "Це замовлення скасовано!",
    "purchase_cancel_dialog_content": "Підтверджуєте скасування замовлення?",
    "yes": "Так",
    "no": "Ні"
},
onSiteService:{
  "name1": "Ремонт у магазині",
  "name2": "Обслуговування на місці",
  "name3": "Щоб скористатися обслуговуванням на місці, потрібно ввімкнути геолокацію. Увімкніть і спробуйте ще раз.",
  "name4": "Виберіть своє місцезнаходження:",
  "name5": "Замовлення на місці",
  "name6": "Поточне розташування:",
  "name7": "Адреса:",
  "name8": "Назва",
  "name9": "Телефон:"
}
};
